<template>
  <div class="wrapper">
    <sidebar/>
    <navbar/>
    <v-content>
      <transition name="page" mode="out-in">
        <router-view/>
      </transition>
    </v-content>
    <v-footer app fixed>
      <!--<v-btn-->
        <!--color="accent"-->
        <!--dark-->
        <!--small-->
        <!--absolute-->
        <!--top-->
        <!--right-->
        <!--fab-->
        <!--@click="toggleThemeSelect"-->
      <!--&gt;-->
        <!--<v-icon>mdi-palette</v-icon>-->
      <!--</v-btn>-->
      <!--<theme-select ref="themeSelect"/>-->
    </v-footer>
  </div>
</template>

<script>
import Sidebar from './Sidebar'
import Navbar from './Navbar'
export default {
  name: 'tradle',

  components: {
    Sidebar,
    Navbar
  },

  data () {
    return {}
  },
  methods: {
    // toggleThemeSelect () {
    //   this.$refs.themeSelect.toggle()
    // }
  }
}
</script>

<style scoped>
  .page-enter-active, .page-leave-active {
    transition: opacity 0.2s;
  }

  .page-enter, .page-leave-to {
    opacity: 0;
  }

  .wrapper {
    display: flex;
    height: 100%;
  }
</style>
